import {FormioBase} from "./formiobase";

export class Content extends FormioBase {
  public inputType = "content";
  public title = "Content";
  public icon = "fab fa-html5";
  public schema: any = {
    title: "Content",
    components: [{
      type: "content",
      inputType: "content",
      key: "content1",
      input: false,
      label: "Content",
      html: "<p>Content</p>",
      customClass: "alert alert-danger ds-content",
    }],
  };
}
